import { render } from "./Section copy.vue?vue&type=template&id=5b64b91d&scoped=true"
import script from "./Section copy.vue?vue&type=script&lang=js"
export * from "./Section copy.vue?vue&type=script&lang=js"

import "./Section copy.vue?vue&type=style&index=0&id=5b64b91d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b64b91d"]])

export default __exports__